import React from 'react';
import { connect } from 'react-redux';

import Confirmation from '../../views/confirmation/Confirmation.jsx';
import Cancelation from '../../views/Cancelation/Cancelation.jsx';
import NewCofForm from '../../views/NewCofForm/NewCofForm.jsx';
import MultiHotelAvail from '../../views/multiHotelAvail/MultiHotelAvail.jsx';
import MonoHotelAvail from '../../views/monoHotelAvail/MonoHotelAvail.jsx';
import ServiceHotelAvail from '../../views/serviceHotelAvail/ServiceHotelAvail.jsx';
import CustomerForm from '../../views/customerForm/CustomerForm.jsx';
import styleFile from './StepManager.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

import { compose, contains } from 'ramda';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { Loading } from '@synergycms_core/components/functional/Loading';
import propertyManager from '@synergycms_core/components/HoC/propertyManager';

class StepManager extends React.Component {
  static displayName = 'StepManager';
  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.config.code !== this.props.config.code) {
      window.document.body.scrollTop = window.document.documentElement.scrollTop = 0;
    }
  };

  render() {
    const {theme} = this.props;
    const { classes } = theme.styles;
    let selected = null;

    switch (this.props.config.code) {
      case 'multiHotelAvail':
        selected = <MultiHotelAvail />;
        break;
      case 'monoHotelAvail':
        selected = <MonoHotelAvail />;
        break;
      case 'serviceHotelAvail':
        selected = <ServiceHotelAvail />;
        break;
      case 'customerForm':
        selected = <CustomerForm />;
        break;
      case 'confirmation':
        selected = <Confirmation />;
        break;
      case 'cancelation':
        selected = <Cancelation />;
        break;
      case 'newCof':
        selected = <NewCofForm />;
        break;
      default:
        selected = <div />;
    }

    return <div className={[this.props.theme.styles.wrapper,classes.containerSteps].join(' ')}>{selected}</div>;
  }
}

const mapStateToProps = store => {
  return {
    code: store.getIn(['customer', 'step', 'current_step', 'code']),
    loaded: store.getIn(['customer', 'step', 'loaded']) || undefined
  };
};

const fragment = props => {
  return (
    <React.Fragment>
      <Loading
        image={{ innerStyle: ['displayNone'] }}
        richText={{
          translate: true,
          ucFirst: true,
          innerStyle: ['descriptionText'],
          text: props.code && !contains(props.code, ['cancelation', 'newCof']) && '_%estamos buscando los mejores precios para ti%_'
        }}
      />
    </React.Fragment>
  );
};

export default compose(
  validateAsyncComponent(mapStateToProps, [], fragment),
  connect(mapStateToProps),
  propertyManager(['code', 'loaded']),
  withThemeJSS({ styleFile }),
)(StepManager);
